// ============================================================
// Gemeinsamer Endbildschirm fuer die Klick-Modi
//
// Produkttest 29.08.2026, Befund "Sieben Modi haben keinen Endbildschirm":
// Cricket, Party, Gotcha, Bob's 27, Round the World und Random Checkout
// endeten mit einem Toast und goHome() nach 300-800 ms - keine Platzierung,
// kein "Nochmal", bei Party-Abenden mussten alle Namen neu getippt werden.
//
// Dieser Baustein ist das Gegenstueck zu zeigeSecureEndstand() (der
// Vorlage), aber fuer alle Modi: EIN Modal (#endbildschirm-modal in
// index.html), das jeder Modus nur mit Zeilen fuettert.
//
//   zeigeEndbildschirm({
//     screenId:   "game-cricket-screen",     // wird beim Verlassen versteckt
//     titel:      tf("js.ende.sieg", {...}), // fertig uebersetzter Text
//     untertitel: "...",                     // optional, z. B. der alte Toast
//     zeilen:     [{ name, wert, aktiv }],   // Rangliste; aktiv = Sieger
//     kennzahlen: [{ label, wert }],         // optional, kleine Kacheln
//     revanche:   () => startXGame(),        // optional; Setup-Formular
//                                            // haelt die Werte noch
//     setup:      () => openXSetup(),        // optional
//   });
//
// BESITZ: Titel, Zeilen und Kennzahlen setzt ausschliesslich dieses Modul
// (kein data-i18n auf diesen Elementen - ein Element, ein Besitzer). Die
// drei Knoepfe sind statisch und tragen ihre Schluessel im Markup
// (ende.revanche / ende.setup / ende.heim).
//
// Die Modi rufen ihre save*StatsBackground() weiterhin SELBST vor dem
// Endbildschirm auf - dieser Baustein zeigt nur an und raeumt auf.
// ============================================================

import { t } from "./i18n.js";

let aktuelleKonfig = null;

function knoten(id) {
  return document.getElementById(id);
}

/** Modal fuellen und zeigen. Fehlt das Markup (fremde Seite), faellt der
 *  Aufrufer nicht auf die Nase: dann Toast + goHome wie frueher. */
function zeigeEndbildschirm(cfg) {
  const modal = knoten("endbildschirm-modal");
  if (!modal) {
    if (typeof showToast === "function" && cfg.titel) showToast(cfg.titel, "success");
    verlasseZumHauptmenue(cfg);
    return;
  }
  aktuelleKonfig = cfg;

  knoten("endbildschirm-titel").textContent = cfg.titel || t("js.ende.fertig");

  const sub = knoten("endbildschirm-untertitel");
  sub.textContent = cfg.untertitel || "";
  sub.style.display = cfg.untertitel ? "" : "none";

  const liste = knoten("endbildschirm-liste");
  liste.innerHTML = "";
  for (const zeile of cfg.zeilen || []) {
    const li = document.createElement("li");
    li.className = "endbildschirm-zeile" + (zeile.aktiv ? " aktiv" : "");
    const name = document.createElement("span");
    name.className = "endbildschirm-name";
    name.textContent = zeile.name;
    const wert = document.createElement("span");
    wert.className = "endbildschirm-wert";
    wert.textContent = zeile.wert;
    li.append(name, wert);
    liste.appendChild(li);
  }
  liste.style.display = (cfg.zeilen || []).length ? "" : "none";

  const kennzahlen = knoten("endbildschirm-kennzahlen");
  kennzahlen.innerHTML = "";
  for (const k of cfg.kennzahlen || []) {
    const zelle = document.createElement("div");
    zelle.className = "endbildschirm-kennzahl";
    const wert = document.createElement("strong");
    wert.textContent = k.wert;
    const label = document.createElement("span");
    label.textContent = k.label;
    zelle.append(wert, label);
    kennzahlen.appendChild(zelle);
  }
  kennzahlen.style.display = (cfg.kennzahlen || []).length ? "flex" : "none";

  // Knoepfe ohne Handler ausblenden - ein Solo-Training ohne Revanche-Weg
  // soll keinen toten Knopf zeigen.
  knoten("endbildschirm-revanche").style.display = cfg.revanche ? "" : "none";
  knoten("endbildschirm-setup").style.display = cfg.setup ? "" : "none";

  modal.style.display = "flex";
}

function schliesseEndbildschirm() {
  const modal = knoten("endbildschirm-modal");
  if (modal) modal.style.display = "none";
}

function verlasseZumHauptmenue(cfg) {
  const screen = cfg && cfg.screenId ? knoten(cfg.screenId) : null;
  if (screen) screen.style.display = "none";
  if (typeof goHome === "function") goHome();
}

function endbildschirmRevanche() {
  const cfg = aktuelleKonfig;
  schliesseEndbildschirm();
  aktuelleKonfig = null;
  if (cfg && cfg.revanche) cfg.revanche();
}

function endbildschirmSetup() {
  const cfg = aktuelleKonfig;
  schliesseEndbildschirm();
  aktuelleKonfig = null;
  if (cfg && cfg.screenId) {
    const screen = knoten(cfg.screenId);
    if (screen) screen.style.display = "none";
  }
  if (cfg && cfg.setup) cfg.setup();
}

function endbildschirmHeim() {
  const cfg = aktuelleKonfig;
  schliesseEndbildschirm();
  aktuelleKonfig = null;
  verlasseZumHauptmenue(cfg);
}

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und die Spielmodule
// greifen global zu (Muster wie in allen uebrigen Modulen).
// ---------------------------------------------------------------
Object.assign(window, {
  zeigeEndbildschirm,
  endbildschirmRevanche,
  endbildschirmSetup,
  endbildschirmHeim,
});
